import { z } from 'zod';
import { MEDIA_TYPES } from '../constants.js';
function emptyStringToNull(schema) {
    return z.preprocess((value) => {
        if (typeof value === 'string' && value.trim() === '') {
            return null;
        }
        return value;
    }, schema);
}
export const storyDtoSchema = z.object({
    id: z.string(),
    mediaUrl: z.string().url(),
    mediaType: z.enum(MEDIA_TYPES),
    durationSec: z.number().int().min(1).max(180),
    ctaText: z.string().nullable(),
    ctaUrl: z.string().url().nullable(),
    order: z.number().int(),
});
export const storyGroupDtoSchema = z.object({
    id: z.string(),
    title: z.string(),
    coverUrl: z.string().url(),
    order: z.number().int(),
    publishedAt: z.string().nullable(),
    expiresAt: z.string().nullable(),
    stories: z.array(storyDtoSchema),
    /** True once the current user has viewed the group's first content item.
     *  Absent in the admin feed (no per-user context). */
    isViewed: z.boolean().optional(),
});
export const createStoryGroupSchema = z.object({
    title: z.string().trim().min(1).max(80),
    coverUrl: z.string().url(),
    order: z.number().int().default(0),
    publishedAt: z.string().datetime({ offset: true }).nullable().optional(),
    expiresAt: z.string().datetime({ offset: true }).nullable().optional(),
});
export const VIDEO_MAX_DURATION_SEC = 30;
export const createStorySchema = z
    .object({
    groupId: z.string(),
    mediaUrl: z.string().url(),
    mediaType: z.enum(MEDIA_TYPES),
    durationSec: z.number().int().min(1).max(180).default(5),
    ctaText: emptyStringToNull(z.string().max(40).nullable().optional()),
    ctaUrl: emptyStringToNull(z.string().url().nullable().optional()),
    order: z.number().int().default(0),
})
    .superRefine((v, ctx) => {
    if (v.mediaType === 'VIDEO' && v.durationSec > VIDEO_MAX_DURATION_SEC) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['durationSec'],
            message: `Максимум ${VIDEO_MAX_DURATION_SEC} секунд для видео`,
        });
    }
});
export const updateStoryGroupSchema = createStoryGroupSchema.partial();
export const updateStorySchema = z.object({
    mediaUrl: z.string().url().optional(),
    mediaType: z.enum(MEDIA_TYPES).optional(),
    durationSec: z.number().int().min(1).max(180).optional(),
    ctaText: emptyStringToNull(z.string().max(40).nullable().optional()),
    ctaUrl: emptyStringToNull(z.string().url().nullable().optional()),
    order: z.number().int().optional(),
});
